import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CrisisBanner from "./CrisisBanner";
import CarePortalChatbox from "./CarePortalChatbox";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  // Show chatbox on all Care Portal pages except admin routes (login, dashboard, and admin sub-pages).
  const showChatbox = pathname.startsWith("/care-portal") && !pathname.startsWith("/care-portal/admin") && !pathname.startsWith("/care-portal/demo");
  return (
    <div className="min-h-screen flex flex-col bg-[#FDFDFD]">
      <CrisisBanner />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      {showChatbox && <CarePortalChatbox />}
    </div>
  );
}
